import Input, { InputProps } from 'Components/Input/Input';
import { FormikValues, useFormikContext } from 'formik';
import React, { useCallback, useEffect } from 'react';
interface Props extends InputProps {
  forceClearInput?: boolean;
}
const FormInput: React.FC<Props> = ({ id, disabled, type, forceClearInput, ...rest }) => {
  const { setFieldValue, getFieldMeta, setFieldTouched, setFieldError } =
    useFormikContext<FormikValues>();

  const isError = getFieldMeta(id).touched && getFieldMeta(id).error && !disabled;

  const handleChangeEvent = useCallback(
    (val: any) => {
      if (
        type === 'number' &&
        typeof val === 'string' &&
        val !== '' &&
        val !== null &&
        !Number.isNaN(+val)
      ) {
        setFieldValue(id, +val);
        return;
      }
      setFieldValue(id, val);
    },
    [id, type, setFieldValue]
  );

  useEffect(() => {
    if (forceClearInput) {
      setFieldValue(id, '');
      setFieldError(id, '');
      setFieldTouched(id, false);
    }
  }, [forceClearInput, id, setFieldError, setFieldTouched, setFieldValue]);

  return (
    <Input
      id={id}
      value={getFieldMeta(id).value}
      errorMessage={isError ? getFieldMeta(id).error : ''}
      disabled={disabled}
      onChange={handleChangeEvent}
      {...rest}
    />
  );
};

export default FormInput;
